module.exports = __webpack_public_path__ + "img/yy-s3.4435b1e0.svg";